import { Signup } from 'components/authentication/signup/Signup';

export const Signuppage = () => {
    return (
        <div>
            <Signup />
        </div>
    );
};
